import { getDictDataList } from '@/api//system/dict'

const state = {
  dictCache: {}
}

const mutations = {
  SET_DICT(state, { dictType, data }) {
    state.dictCache[dictType] = data
  }
}

const actions = {
  // 获取字典数据
  async getDictData({ state, commit }, dictType) {
    // 如果已缓存，直接返回
    if (state.dictCache[dictType]) {
      return state.dictCache[dictType]
    }
    
    try {
      // 否则请求接口
      const res = await getDictDataList(dictType)
      const data = res.data || []
      commit('SET_DICT', { dictType, data })
      return data
    } catch (error) {
      console.error('获取字典数据失败:', dictType, error)
      return []
    }
  },
  
  // 清除字典缓存
  clearDictCache({ commit }, dictType) {
    if (dictType) {
      commit('SET_DICT', { dictType, data: null })
    } else {
      // 清除所有缓存
      commit('SET_DICT', { dictCache: {} })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
